import { render, staticRenderFns } from "./newGuideSign.vue?vue&type=template&id=8c27a254&scoped=true&"
import script from "./newGuideSign.vue?vue&type=script&lang=js&"
export * from "./newGuideSign.vue?vue&type=script&lang=js&"
import style0 from "./newGuideSign.vue?vue&type=style&index=0&id=8c27a254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c27a254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c27a254')) {
      api.createRecord('8c27a254', component.options)
    } else {
      api.reload('8c27a254', component.options)
    }
    module.hot.accept("./newGuideSign.vue?vue&type=template&id=8c27a254&scoped=true&", function () {
      api.rerender('8c27a254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/newGuideSign.vue"
export default component.exports